import { render, staticRenderFns } from "./SiteConfiguration.vue?vue&type=template&id=3c164d46&"
import script from "./SiteConfiguration.vue?vue&type=script&lang=js&"
export * from "./SiteConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports